import React, { useEffect } from 'react'
import NavbarTop from './../components/global/NavbarTop';

import CaseStudiesTelcoContent from './../components/CaseStudies/CaseStudiesTelcoContent';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectLanguage } from './../redux/language/selector';

const CaseStudiesTelco = () => {

  const {t} = useTranslation()

  const language = useSelector(selectLanguage)

  useEffect(() => {
    document.title = t('case-studies-telco-page.case-studies-telco-page-title')
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[language])

  return (
    <>
        <NavbarTop/>
        <CaseStudiesTelcoContent/>
        
    </>
  )
}

export default CaseStudiesTelco